<template>
  <b-col cols="12" class="mt-48 mt-sm-96">
    <p class="hp-p1-body text-center hp-text-color-black-60 mb-8">
      COPYRIGHT ©2024 Принадлежит Аltuera. Все права сохранены
    </p>

    <b-row
      align-h="center"
      align-v="center"
      style="margin-left: -8px; margin-right: -8px"
    >
      <b-col class="w-auto hp-flex-none px-8">
        <b-link :href="privacy_link" class="hp-text-color-black-80 hp-text-color-dark-40">
          Политика конфиденциальности
        </b-link>
      </b-col>

      <b-col class="w-auto hp-flex-none px-8">
        <b-link :href="terms_of_use" class="hp-text-color-black-80 hp-text-color-dark-40">
          Условия пользования
        </b-link>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { BRow, BCol, BLink } from "bootstrap-vue";

import Logo from "@/layouts/components/logo";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    Logo,
  },
  data() { 
    return {
      privacy_link: process.env.VUE_APP_PRIVACY_POLICY,
      terms_of_use: process.env.VUE_APP_TERMS_OF_USE,
    };
  }
};
</script>
